import { Material } from "three";
import { frameSettings as FrameSettings } from "shared/utils/doorConfigurations";
import { BeamVertical } from "../components/BeamVertical";
import { getGeometryBounds2D } from "../components/openingGeometry";
import type { ScharnierGLTFResult } from "../scharnier/ScharnierType";
import type { VerticalBeamPosition } from "entities/configurator/model/layoutMeta";
import { standingDoorBeamInsetMeters } from "entities/configurator/model/layoutGeometry";
import { getLocalVerticalBeamX } from "./verticalLayoutUtils";
import { getScharnierVerticalFrameEdges } from "./scharnierVerticalLayoutUtils";

export const ScharnierVerticalLayout = ({
  nodes,
  material,
  width,
  height,
  semanticPosition,
  frameSettings,
}: {
  nodes: ScharnierGLTFResult["nodes"];
  material: Material;
  width: number;
  height: number;
  semanticPosition: VerticalBeamPosition | undefined;
  frameSettings?: FrameSettings;
}) => {
  const isVisible = semanticPosition !== undefined;
  const leftBounds = getGeometryBounds2D(nodes.frame_left.geometry);
  const rightBounds = getGeometryBounds2D(nodes.frame_right.geometry);
  const topBounds = getGeometryBounds2D(nodes.frame_top.geometry);
  const bottomBounds = getGeometryBounds2D(nodes.frame_bottom.geometry);
  const beamBounds = getGeometryBounds2D(nodes.beam_vertical.geometry);
  const parentScaleX = frameSettings?.generalScaleX ?? 1;

  const { left, right, top, bottom } = getScharnierVerticalFrameEdges({
    width,
    height,
    leftBounds,
    rightBounds,
    topBounds,
    bottomBounds,
    frameTopScaleY: frameSettings?.frameTop?.scaleY,
    frameTopShiftY: frameSettings?.frameTop?.shiftY,
  });
  const beamX = isVisible
    ? getLocalVerticalBeamX(semanticPosition, left, right, beamBounds, {
        insetMeters: standingDoorBeamInsetMeters,
        parentScaleX,
      })
    : 0;

  return (
    <BeamVertical
      visible={isVisible}
      geometry={nodes.beam_vertical.geometry}
      material={material}
      x={beamX}
      bottom={bottom}
      top={top}
      scaleX={1 / parentScaleX}
    />
  );
};
